<template>
        <v-row>
            <v-col cols="12">
                <div class="headline">Tourvorlagen</div>
                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="far fa-search"
                                label="Suchen"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="tables.tour.header"
                            :items="tourTemplate"
                            :search="search"
                            class="mb-4"
                            no-data-text="Keine Tourvorlagen vorhanden"
                            :items-per-page="15"
                    >
                      <template v-slot:item.identifier="{ item }">
                        <v-btn depressed fab small dark :color="'#' + item.color">{{ item.identifier }}</v-btn>
                      </template>
                      <template v-slot:item.vehicle="{ item }">
                        <Vehicle :vehicle-i-d="item.vehicle"></Vehicle>
                      </template>
                      <template v-slot:item.cityAndDistrict="{ item }">
                        <v-chip v-for="district in item.cityAndDistrict" class="city ma-1" :key="district">
                          {{ district }}
                        </v-chip>
                      </template>
                      <template v-slot:item.action="{ item }">
                        <v-btn icon :to="{ name: 'tourtemplate-edit', params: { id: item.id }}">
                            <v-icon >far fa-edit</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                </v-card>
              <v-card-actions>
                <v-btn color="primary" :to="{ name: 'tourtemplate-edit', params: { id: 0 }}">Neue Tourvorlage</v-btn>
              </v-card-actions>
            </v-col>
        </v-row>
</template>

<script>
import Vehicle from './partials/_vehicle'
const filters = {
  all: items => items,
  new: items => items.filter(item => item.tour === 0)
}

export default {
  name: 'TourTemplate',
  components: {Vehicle},
  computed: {
    duties () {
      return filters['new'](this.$store.state.duties)
    },
    tourTemplate () {
      return this.$store.state.tourTemplate.all
    }
  },
  methods: {
    getVehicle (id) {
      let vehicle = this.$store.state.vehicle.all.find(vehicle => vehicle.id === id)
      if (vehicle === undefined) {
        return {
          title: '',
          color: ''
        }
      }
      return vehicle
    }
  },
  data: () => ({
    search: '',
    tables: {
      tour: {
        header: [
          {text: 'Kennung', value: 'identifier'},
          {text: 'Fahrzeug', value: 'vehicle'},
          {text: 'Name', value: 'name'},
          {text: 'Maximale Auslastung', sortable: false, value: 'max_weight'},
          {text: '', sortable: false, value: 'action'}
        ]
      }
    }
  })
}
</script>

<style scoped lang="scss">
    @import "../scss/settings";

    .md-table {
        margin-bottom: 1rem;
    }

    .action.md-icon {
        color: $primary-color;
    }

    .city {
        display: inline-block;
        padding-right: 0.75rem;
    }

    .nearlyFull {
        color: orange;
    }

    .full {
        color: red;
    }
</style>



// WEBPACK FOOTER //
// src/components/TourTemplate.vue